<script setup lang="ts">
import AppButton from '~/components/AppButton.vue'
import type { CmsCustomComponentType } from '~/layers/cms/app/types/cmsTypes'

const props = defineProps<{
  cmsDataPath: (string | number)[]
}>()
const nazwa_komponentu = 'Teksty/LeftText'
const component_default_values: CmsCustomComponentType = {
  id: { value: undefined, default_value: 'Lorem Ipsum', settingType: 'text', setting_label: 'zmien id' }
}
</script>

<template>
  <CmsCustomComponent
    v-slot="{ component_values }"
    :cms-data-path="[...props.cmsDataPath]"
    :component-name="nazwa_komponentu"
    :defaults="component_default_values"
    :open-options="true"
  >
    <div
      :id="component_values?.id?.value"
      class="px-2xl py-10 flex flex-col gap-15 bg-background-1"
    >
      <div class="flex flex-col gap-7.5">
        <span class="text-H2 text-Tekst">
          <CmsText
            :cms-data-path="[...props.cmsDataPath, 'component_data', 'text_1']"
          />
        </span>
        <span class="text-H4 text-Tekst">
          <CmsText
            :cms-data-path="[...props.cmsDataPath, 'component_data', 'text_2']"
          />
        </span>
        <div class="w-fit">
          <CmsLink
            v-slot="{ link }"
            :cms-data-path="[...props.cmsDataPath, 'component_data', 'link']"
          >
            <AppButton
              button-theme="Primary"
              :href="link?.href"
              :target="link?.target"
            >
              <span class="link-text">{{ link?.link_text ?? 'Lorem Ipsum' }}</span>
            </AppButton>
          </CmsLink>
        </div>
      </div>
    </div>
  </CmsCustomComponent>
</template>
